import paths from 'paths.json';

export const redirectToSignIn = (accountSelectorGoLiteOnly: boolean = false, forceReAuthentication: boolean = false) => {
    let returnUrl = new URL(paths.Account.SigninCallback, window.location.origin).toString();
    let signinUrl = `/api/v1/account/auth/sign_in?returnUrl=${encodeURIComponent(returnUrl)}&accountSelectorGoLiteOnly=${accountSelectorGoLiteOnly}&forceReAuthentication=${forceReAuthentication}`;
    //console.debug(`useRestGet: 401: redirecting to ${signinUrl}...`);
    window.location.replace(signinUrl);
}